var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtencion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21-1.5A22.493,22.493,0,0,1,36.91,36.91,22.5,22.5,0,1,1,12.242.269,22.36,22.36,0,0,1,21-1.5Zm0,42A19.5,19.5,0,1,0,1.5,21,19.522,19.522,0,0,0,21,40.5Z",
    transform: "translate(2.5 2.5)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11-1.5A12.5,12.5,0,0,1,23.5,11,12.5,12.5,0,0,1,11,23.5,12.5,12.5,0,0,1-1.5,11,12.5,12.5,0,0,1,11-1.5Zm0,22A9.5,9.5,0,1,0,1.5,11,9.511,9.511,0,0,0,11,20.5Z",
    transform: "translate(12.5 12.5)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,13.061A1.5,1.5,0,0,1,12.439,10.5L19,3.939a1.5,1.5,0,0,1,2.121,2.121l-6.561,6.561A1.5,1.5,0,0,1,13.5,13.061Z",
    transform: "translate(17.867 4.061)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.061,21.561A1.5,1.5,0,0,1,19,21.121l-6.561-6.561a1.5,1.5,0,1,1,2.121-2.121L21.121,19a1.5,1.5,0,0,1-1.061,2.561Z",
    transform: "translate(17.867 17.867)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,21.561A1.5,1.5,0,0,1,3.939,19L10.5,12.439a1.5,1.5,0,1,1,2.121,2.121L6.061,21.121A1.5,1.5,0,0,1,5,21.561Z",
    transform: "translate(4.061 17.867)",
    fill: "#0f192d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.561,13.061a1.5,1.5,0,0,1-1.061-.439L3.939,6.061A1.5,1.5,0,0,1,6.061,3.939L12.621,10.5a1.5,1.5,0,0,1-1.061,2.561Z",
    transform: "translate(4.061 4.061)",
    fill: "#0f192d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtencion);
export default __webpack_public_path__ + "static/media/atencion.fc9beb868846b6df11dcf413a794b40a.svg";
export { ForwardRef as ReactComponent };